import React from 'react';

import Button from '../Button';
import { getDomain } from '../../utils/functions';
interface Props {
  image: {
    src: string;
    alt: string;
  };
  heroTitle?: string;
  heroDesc?: string;
  link?: {
    title: string;
    url: string;
  };
  heroButton?: JSX.Element | null;
}

const HeroImage: React.FC<Props> = (props: Props): JSX.Element => {
  const classNames = ['hero', 'relative', 'h-72', 'md:h-full'].join(' ');
  const domain = getDomain();
  const drupalBaseUrl: { [key: string]: string } = {};
  drupalBaseUrl['ruka'] = process.env.REACT_APP_DRUPAL_BASE_URL_RUKA ?? '';
  drupalBaseUrl['pyha'] = process.env.REACT_APP_DRUPAL_BASE_URL_PYHA ?? '';

  return (
    <div>
      <div className={classNames}>
        <img
          src={`${drupalBaseUrl[domain]}/${props.image.src}`}
          className={['h-full', 'md:h-96', 'w-full', 'object-cover'].join(' ')}
          alt={props.image.alt}
        />
        <div
          className={[
            'hero-text',
            'text-center',
            'absolute',
            'inset-0',
            'w-full',
            'flex',
            'flex-wrap',
            'flex-col',
            'items-center',
            'justify-center',
            'gap-y-5',
            'px-5',
            'z-10',
          ].join(' ')}
        >
          {props.heroTitle && (
            <h1
              className={
                'hero-text--title text-xl md:text-3xl font-rukaNeueBold'
              }
            >
              {props.heroTitle}
            </h1>
          )}
          {props.heroDesc && (
            <p
              className='hero-text--description'
              dangerouslySetInnerHTML={{ __html: props.heroDesc }}
            ></p>
          )}
          {props.link && (
            <Button href={props.link.url}>{props.link.title}</Button>
          )}
          {props.heroButton && props.heroButton}
        </div>
        <div className='absolute bg-white opacity-60 w-full h-full top-0'></div>
      </div>
    </div>
  );
};

export default HeroImage;
